import { useState } from 'react'

import { Tick04Icon } from '@hugeicons-pro/core-solid-rounded'

import { HugeiconsIcon } from '@hugeicons/react'

import { useLevelContext } from '@/features/level-play'
import { useFlow } from '@/shared/lib/steps-flow'

const messages = [
  'Boa, essa era a resposta certa!',
  'Parabéns, você acertou!',
  'Na mosca! Você está indo bem.',
  'Ótimo trabalho! Continue assim.',
  'Mandou bem! Resposta correta.',
  'Você acertou! Vamos para a próxima.',
  'Isso aí! Você está no caminho certo.',
  'Muito bom! Seu raciocínio está afiado.',
  'Resposta certa! Seu progresso é incrível.',
  'Acertou! Continue focado e avançando.'
]

export const LevelFooterRightAnswerAlert = () => {
  const { state } = useFlow()

  if (state.phase !== 'CORRECT') return null

  const currentStep = state.steps[state.currentIndex]
  const { challenges } = useLevelContext()
  const challenge = challenges.find(
    challenge => challenge.id === currentStep.challengeId
  )
  const saveAnswer = challenge?.meta?.save_answer ?? false

  const [message] = useState(
    () => messages[Math.floor(Math.random() * messages.length)]
  )

  return (
    <div className="absolute bottom-[-30px] left-0 w-full px-6 pt-6 pb-20 border-t bg-success rounded-b-xl md:pt-8 md:px-8">
      <div className="max-w-5xl mx-auto">
        <div className="flex flex-col gap-2 mb-2 mb-md-5">
          <div className="flex items-center gap-2 ">
            <HugeiconsIcon
              icon={Tick04Icon}
              variant="duotone"
              className="text-white"
              size={20}
            />
            <span className="font-sans text-lg font-bold text-white">
              Resposta {saveAnswer ? 'salva' : 'correta'}
            </span>
          </div>
          {!saveAnswer && (
            <span className="text-base text-white">{message}</span>
          )}
        </div>
      </div>
    </div>
  )
}
